<template>
  <user-center-slot>
    <user-center-container-slot>
        <!-- 左侧菜单栏 -->
        <user-center-menu />
        <!-- 右侧内容 -->
          <user-center-content-slot>
             <user-center-content-title title="我的漏洞" />
            <div class="user-center__vlun-row">
              <div>
                <i class="iconfont icon-jinggao user-center__vlun-icon--default"></i>
              </div>
              <div class="user-center__vlun-number"> 您有<span id="msgNum" class="user-center__vlun-number-txt"> {{ total }}</span>个漏洞</div>
            </div>

            <div class="user-center__msg-operation">
              <xui-select v-model="status" class="user-center__msg-operation-item" placeholder="ALL" clearable @change="listStatus">
                    <xui-option v-for="item in statusOption" :key="item.key" class="item-dropdown" :label="item.label" :value="item.value" />
                </xui-select>
                <xui-input v-model.trim="vulTitle" class="user-center__msg-operation-item" suffix-icon="fa fa-search" autocomplete="off" placeholder="漏洞名称" @blur="list"></xui-input>
            </div>

            <div class="user-center__vlun-list">
              <xui-table :data="latestData" :stripe="false" border :show-header="true" style="width: 100%">
                <!-- prop="${creationDate.format("yyyy/MM/dd hh:mm:ss")}" -->
                <xui-table-column prop="creationDate" label="提交时间" align="left"> </xui-table-column>

                <xui-table-column prop="vulTitle" title="vulTitle" label="漏洞名称">
                  <template slot-scope="scope">
                    <div class="user-center__vlun-item-title">
                        <a :title="scope.row.vulTitle" href="javascript:void(0);" class="user-center__vlun-list-link" @click="toDetail(scope.row)">{{ scope.row.vulTitle }}</a>
                        <span v-if="scope.row&&scope.row.leavingMsgCount>0" class="user-center__vlun-msg--unread">{{ scope.row.leavingMsgCount }}</span>
                    </div>
                  </template>
                </xui-table-column>

                <xui-table-column prop="displayStatusName" class="is-top" min-width="70" label="状态"> </xui-table-column>

                <xui-table-column label="漏洞等级">
                  <template slot-scope="scope">
                    {{ scope.row.vulLevel ? vulLevelOption[scope.row.vulLevel].label : '' }}
                  </template>
                </xui-table-column>

                <xui-table-column prop="amount" label="奖励金额"> </xui-table-column>

                <!-- <xui-table-column
                  label="操作">
                    <template slot-scope="scope">
                      <router-link :to="{path:'/usercenter/report/detail', query:{code: scope.row.code}}">
                        <xui-button type="text">查看</xui-button>
                      </router-link>
                    </template>
                </xui-table-column> -->
              </xui-table>
            </div>

            <div class="user-center__vlun-pager">
              <xui-pagination :current-page.sync="currentPage" :page-size="5" layout="total, pager, jumper" :total="pageTotal" @current-change="handleCurrentChange"> </xui-pagination>
            </div>
        </user-center-content-slot>
    </user-center-container-slot>
    <!-- 荣耀安全应急响应中心服务条款弹框 -->
    <xui-dialog title="" class="warnning-wrap" :close-on-click-modal="false" showcenter :visible.sync="dialogVisible" :width="$store.state.isMobile ? '80%': '30%'" :before-close="handleClose">
      <h3 :style="{'font-size': $store.state.isMobile ? '24px': '16.5px'}">荣耀安全应急响应中心服务条款</h3>
      <div class="content-wrap" :style="{'font-size': $store.state.isMobile ? '22px': '14px'}">
        <p>欢迎您使用荣耀安全应急响应中心（Honor Security Response Center）服务，本平台在特定场景下需收集您的如下信息:</p>
      <ul>
          <li>真实姓名，身份证正反面照片及身份证号；</li>
          <li>银行卡号，开户行信息，银行名称；</li>
          <li>手机号码，邮寄地址；</li>
          <li>昵称，头像，邮箱，主页；</li>
          <li>QQ，微信，签名，团队；</li>
          <li>IP地址；</li>
          <li>为防止欺骗行为，荣耀需采集浏览器信息（类型、时区、插件、语言、字体、canvas图片渲染哈希值、webgl图片渲染哈希值）；</li>
        </ul>
        <p>上述数据将会传输并保存至位于中华人民共和国境内的服务器。</p>
        <span
          >点击“同意”，即表示您同意
          <a :href="safetyURL" target="_blank" class="honor-security-user-protocol">荣耀安全应急响应中心用户协议</a>
          ，并知悉
          <a :href="privacyURL" target="_blank" class="honor-security-secret-statement">关于安全应急响应中心与隐私的声明</a>。</span
        >
      </div>
      <span slot="footer" center>
        <xui-button size="bigger" @click="handleClose">取消</xui-button>
        <xui-button type="primary" size="bigger" @click="confirm">同意</xui-button>
      </span>
    </xui-dialog>
    <!-- 登录提示弹框 -->
    <xui-dialog v-if="isNotLogin && isEffect" title="失效提醒" class="login-dialog" :close-on-click-modal="false" showcenter :visible.sync="isNotLogin" width="30%" @close="handleClose">
      <span>您的账号已经失效，请联系管理员</span>
      <span slot="footer" class="dialog-footer" center>
        <xui-button type="primary" size="bigger" @click="handleClose">返回首页</xui-button>
      </span>
    </xui-dialog>
    <xui-dialog v-else title="登录提醒" class="login-dialog" :close-on-click-modal="false" showcenter :visible.sync="isNotLogin" width="30%" @close="handleClose">
      <span>系统检测到您未登录或登录失效，请先登录</span>
      <span slot="footer" class="dialog-footer" center>
        <xui-button type="primary" size="bigger" @click="login">荣耀账号登录</xui-button>
      </span>
    </xui-dialog>
  </user-center-slot>
</template>
<script>
import UserCenterMenu from '../../../components/pages/UserCenterMenu'
import UserCenterContainerSlot from '../../../components/pages/UserCenterContainerSlot'
import UserCenterSlot from '../../../components/pages/UserCenterSlot'
import UserCenterContentSlot from '../../../components/pages/UserCenterContentSlot'
import UserCenterContentTitle from '../../../components/pages/UserCenterContentTitle'
import router from '../../../router/index.js';
import { v4 } from 'uuid';
import { mapState } from 'vuex';
import store from '../../../store/index'

export default {
  name: 'usercenterReport',
  components: {
    UserCenterMenu,
    UserCenterSlot,
    UserCenterContainerSlot,
    UserCenterContentSlot,
    UserCenterContentTitle
  },
  computed: {
    ...mapState(['unReadBbsCount', 'unReadMsgListCount'])
  },
  data() {
    return {
      safetyURL: '',
      privacyURL: '',
      isEffect: false,
      isNotLogin: false,
      currentPage: 1,
      pageSize: 5,
      total: 0,
      dialogVisible: false,
      pageTotal: 0,
      status: '',
      statusData: [],
      vulTitle: '',
      // 1，2，3 已受理
      // 4，5 已确认
      // 6，7，8，9 已支付
      // 10 已关闭
      statusTableOption: [
        {
          key: '1',
          label: '已受理',
          value: 1
        },
        {
          key: '2',
          label: '已受理',
          value: 2
        },
        {
          key: '3',
          label: '已受理',
          value: 3
        },
        {
          key: '4',
          label: '已确认',
          value: 4
        },
        {
          key: '5',
          label: '已确认',
          value: 5
        },
        {
          key: '6',
          label: '已支付',
          value: 6
        },
        {
          key: '7',
          label: '已支付',
          value: 7
        },
        {
          key: '8',
          label: '已支付',
          value: 8
        },
        {
          key: '9',
          label: '已支付',
          value: 9
        },
        {
          key: '10',
          label: '已关闭',
          value: 10
        }
      ],
      statusOption: [
        {
          key: '2',
          label: '已受理',
          value: 2
        },
        {
          key: '4',
          label: '已确认',
          value: 4
        },
        {
          key: '6',
          label: '已支付',
          value: 6
        },
        {
          key: '10',
          label: '已关闭',
          value: 10
        }
      ],
      vulLevelOption: [
        {
          key: '0',
          label: '未定级',
          value: 0
        },
        {
          key: '1',
          label: '严重',
          value: 1
        },
        {
          key: '2',
          label: '高危',
          value: 2
        },
        {
          key: '3',
          label: '中危',
          value: 3
        },
        {
          key: '4',
          label: '低危',
          value: 4
        }
      ],
      latestData: []
    };
  },
  mounted() {
    // 登陆状态时，获取CSRF
    this.getCSRF();
    this.getUserInfo();
    this.safetyURL = window.sessionStorage.getItem('safetyURL');
    this.privacyURL = window.sessionStorage.getItem('privacyURL');
    setTimeout(() => {
      if (this.isNotLogin) {
        return;
      }
    }, 50);
  },
  methods: {
    getUserInfo() {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/user/getUserInfo')
          .then(res => {
            if (res.data && res.data.status === 200) {
              store.commit('setUnReadBbsCount', res.data.data.unReadBbsCount)
              store.commit('setUnReadMsgListCount', res.data.data.unReadMsgListCount)
              store.commit('setUnReadSiteMsgCount', res.data.data.unReadSiteMsgCount)
              this.isNotLogin = false;
             this.list();
             this.count();
            } else {
              this.isNotLogin = true;
            }
          })
          .catch(error => {
            if (error.response && error.response.data && error.response.data.code === 'hihonor.account.00010010') {
              this.isEffect = true;
              this.isNotLogin = true;
            }
          });
      });
    },
    login: function() {
      this.loginHandle();
    },
    // 点击登录
    loginHandle: function() {
      let client_id = '',
        login_channel = '',
        req_client_type = '',
        redirect_uri = '',
        scope = '';
      for (let metas = document.getElementsByTagName('meta'), i = 0; i < metas.length; ++i) {
        switch (metas[i].name) {
          case 'client_id':
            client_id = metas[i].content;
            break;
          case 'login_channel':
            login_channel = metas[i].content;
            break;
          case 'req_client_type':
            req_client_type = metas[i].content;
            break;
          case 'redirect_uri':
            redirect_uri = metas[i].content;
            break;
          case 'scope':
            scope = metas[i].content;
            break;
          default:
            break;
        }
      }
      const stautusData = v4();
      const authURL = window.location.host === 'security.honor.com' ? 'https://hnoauth-login-drcn.cloud.honor.com/oauth2/v3/authorize?' : 'https://hnoauth-login-test-drcn.cloud.honor.com/oauth2/v3/authorize?';
      const redirectUrl =
        authURL +
        'response_type=code&access_type=offline&state=' +
        stautusData +
        '&client_id=' +
        client_id +
        '&login_channel=' +
        login_channel +
        '&req_client_type=' +
        req_client_type +
        '&redirect_uri=' +
        redirect_uri +
        '&scope=' +
        scope;

      window.location.href = redirectUrl;
    },
    handleClose: function() {
      this.$router.push({ path: '/' });
    },
    getCSRF: function() {
      const that = this;
      const options = {
        withCredentials: true,
        headers: {
          'x-csrf-token': null
        }
      };

      const s = new Promise((resolve, reject) => {
        this.$http
          .get('common/hsrc/vul/common/services/jalor/web/support/workspace/current', { headers: { 'x-celon-admin': true, 'x-sub-app-id': 'hsrc_vul' } })
          .then(res => {
            if (res['headers']['x-csrf-token']) {
              window.sessionStorage.setItem('x-csrf-token', res['headers']['x-csrf-token']);
            } else {
              this.isNotLogin = true;
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    // 左侧切换路由
    selectHandle: (index, indexPath) => {
      if (index === '1') {
        router.push({ path: '/usercenter/info' });
      }
      if (index === '2') {
        router.push({ path: '/usercenter/idinfo' });
      }
      if (index === '3') {
        router.push({ path: '/usercenter/report' });
      }
      if (index === '4') {
        router.push({ path: '/usercenter/sitemsg' });
      }
      if (index === '5') {
        router.push({ path: '/usercenter/teamMenu' });
      }
    },
    // 翻页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.list('page');
    },
    toDetail(data) {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/user/getUserInfo')
          .then(res => {
            console.log(res);
            if (res.data && res.data.status === 200) {
              this.$router.push({
                name: 'usercenterReportDetail',
                query: {
                  vulId: data.vulId
                }
              });
              // this.$bus.$emit('send', res.data.data.unReadSiteMsgCount);
              store.commit('setUnReadBbsCount', res.data.data.unReadBbsCount)
              store.commit('setUnReadMsgListCount', res.data.data.unReadMsgListCount)
              store.commit('setUnReadSiteMsgCount', res.data.data.unReadSiteMsgCount)
              // 如果是登录状态，就验证是否签名.
              // this.query();
              // 确认是否完善个人信息
            } else {
              this.isNotLogin = true;
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    // 确认个人签名
    confirm: function() {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/autograph/save', { headers: { 'x-csrf-token': window.sessionStorage.getItem('x-csrf-token') } })
          .then(res => {
            // 保存成功后，放开修改
            if (res.status === 200) {
              this.dialogVisible = false;
            } else {
              this.dialogVisible = true;
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    query() {
      const s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/autograph/query', { headers: { 'x-csrf-token': window.sessionStorage.getItem('x-csrf-token') } })
          .then(res => {
            // 接口直接返回布尔值，false时为未签名，弹出签名窗
            if (!res.data) {
              this.dialogVisible = true;
            } else {
              this.dialogVisible = false;
              // 为true时，为签名验证已过，不需要签名
              // 已签名状态，就初始化验证码和奖励计划
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    // 查询我的漏洞列表
    listStatus: function() {
      this.statusData = [];
      if ('' != this.status) {
        this.statusData.push(this.status);
      }
      this.list();
    },
    list: function(v) {
      const s = new Promise((resolve, reject) => {
        const params = {
          statusList: this.statusData,
          vulTitle: this.vulTitle
        };
        if (params.statusList[0] === 2) {
          params.statusList = [1, 2, 3];
        }
        if (params.statusList[0] === 4) {
          params.statusList = [4, 5];
        }
        if (params.statusList[0] === 6) {
          params.statusList = [6, 7, 8, 9];
        }
        // 不是翻页的情况下，当前页重置为1
        if (!v) {
          this.currentPage = 1;
        }
        this.$http
          .post(`vul/hsrc/vul/report/services/vul/list/page/${this.pageSize}/${this.currentPage}`, params)
          .then(res => {
            if (res.data && res.data.status === 200) {
              this.latestData = res.data.data.result || [];
              // 不论是否翻页，当前总条数以实际返回为准
              this.pageTotal = res.data.data.pageVO.totalRows;
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    count: function() {
      const s = new Promise((resolve, reject) => {
        const params = {};
        this.$http
          .post(`vul/hsrc/vul/report/services/vul/count`, params)
          .then(res => {
            console.log(res);
            if (res.status === 200) {
              this.total = res.data;
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    }
  }
};
</script>
<style lang="less" scoped>
.toDetail-button{
  max-width: 80%;
  text-overflow: ellipsis;
  overflow: hidden;
}

.warnning-wrap {
  /deep/.xui-dialog {
    min-width: 540px !important ;
  }
  h3 {
    text-align: center;
  }
  .content-wrap {
    padding: 60px 10px;
    ul {
      padding-left: 20px;
    }
    span a {
      text-decoration: none;
    }
  }
  .xui-button--primary {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    &:hover {
      background: #66b1ff !important;
      border-color: #66b1ff;
      color: #fff;
    }
  }
}



/deep/.xui-table__empty-text {
  display: none;
}
.login-dialog {
  /deep/.xui-dialog {
    min-width: 540px !important ;
  }
  /deep/.xui-dialog__grayheader .xui-dialog__titleBox {
    text-align: center !important;
    .xui-dialog__graytitle {
      font-size: 1.2rem !important;
      font-weight: normal;
      padding-left: 0;
    }
  }
  /deep/.xui-dialog__body {
    padding: 0 2rem !important;
    font-size: 1rem !important;
    line-height: 2;
    text-align: center;
  }
  /deep/.xui-dialog__footer {
    text-align: center;
    padding: 2rem !important;
  }
  /deep/.xui-button.xui-button--primary {
    background: #409eff;
    border-color: #409eff;
    &:hover {
      background: #66b1ff;
      border-color: #66b1ff;
    }
    span {
      color: #fff;
      font-size: 0.8rem !important;
      font-weight: normal;
    }
  }
}

// 20220812界面改版需求新增
.user-center__vlun-row{
  display:flex;
  align-items: center;
  padding: 20px 50px;
}

.user-center__vlun-icon--default{
  display: inline-block;
  width: 84px;
  height: 84px;
  line-height: 84px;
  border-radius: 50%;
  font-size: var(--src--text-size-large-extra10);
  background: var(--src-bg-color-dark1);
  text-align: center;
  color: var(--src-text-color-white);
}

.user-center__vlun-number{
  margin-left: 20px;
  cursor: pointer;
}

.user-center__vlun-number-txt{
    font-size: var(--src--text-size-large);
    color: var(--src-bg-color-blue-dark1);
    font-weight: var(--src-text-weight-dark1);
}

.user-center__msg-operation{
    display: flex;
    justify-content: flex-end;
    padding: 20px 50px 15px;
}

/deep/.user-center__msg-operation .xui-input__inner,
/deep/.xui-input .xui-input__icon-height .fa {
  height: 36px !important;
  line-height:34px !important;
}

.user-center__msg-operation-item{
  width: 200px;
  margin-left: 10px;
}


.user-center__vlun-list{
  width: 99%;
  padding: 0 50px;
  overflow: hidden;
}

/deep/.user-center__vlun-list .xui-table{
  border-right:1px solid var(--src-color-secondary-light7);
  font-size: var(--src--text-size-default);
}

/deep/.user-center__vlun-list .xui-table th .cell{
  color: var(--src-color-primary-dark6);
  font-weight: var(--src-text-weight-light1);
}

/deep/.user-center__vlun-list .xui-table th .cell,
/deep/.user-center__vlun-list .xui-table td .cell
{
  padding: 0 10px;
}

/deep/.user-center__vlun-list .xui-table th,
/deep/.user-center__vlun-list .xui-table td{
  border-left:1px solid var(--src-color-secondary-light7);
  border-top:1px solid var(--src-color-secondary-light7);
  border-bottom: none;
}

.user-center__vlun-item-title{
  display: flex;
}

.user-center__vlun-list-link{
  // max-width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--src-bg-color-blue-dark1);
}

@media only screen and (max-width: 1000px) {
  .user-center__vlun-list-link{
    max-width: 63px;
  }
}

.user-center__vlun-msg--unread{
    height: 15px;
    line-height: 15px;
    padding: 0 4px;
    background-color: var(--src-bg-color-red-light1);
    font-size: 12px;
    color: var(--src-text-color-white);
    border-radius: 7px;
    max-width: 66px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.user-center__vlun-pager{
  padding: 20px 50px 0;
}


</style>



// WEBPACK FOOTER //
// src/views/usercenter/report/UsercenterReport.vue